import React from "react";
import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { ExportDataTypeInclusionSelector } from "./ExportDataTypeInclusionSelector";
import { EXPORT_INCLUSION_TYPES, type ExportFieldConfiguration } from "./types";
import { getCommonExportRatioOptions } from "./utils";
import { FieldConfigurationSelector } from "./FieldConfigurationSelector";
import {
  rowBasedSpendExportFields,
  firmographicsExportFields,
} from "./exportConfigurationFields";

const DATA_TYPE = "Row-Based Spend";

interface Props {
  inclusion: EXPORT_INCLUSION_TYPES;
  setInclusion: (value: EXPORT_INCLUSION_TYPES) => void;
  fieldConfiguration: ExportFieldConfiguration;
  setFieldConfiguration: (cfg: ExportFieldConfiguration) => void;
  includeSMB: boolean;
  setIncludeSMB: (value: boolean) => void;
}

export const RowBasedSpendExportOptions: React.FC<Props> = ({
  inclusion,
  setInclusion,
  fieldConfiguration,
  setFieldConfiguration,
  includeSMB,
  setIncludeSMB,
}) => {
  const isDisabled = inclusion === EXPORT_INCLUSION_TYPES.NONE;

  return (
    <Stack spacing={2} sx={{ width: "70%", paddingTop: "40px" }}>
      <Typography variant="h5" fontWeight={500} fontSize={16}>
        Row-Based Spend
      </Typography>
      <ExportDataTypeInclusionSelector
        dataType={DATA_TYPE}
        options={getCommonExportRatioOptions(DATA_TYPE)}
        inclusion={inclusion}
        setInclusion={setInclusion}
      />
      <FieldConfigurationSelector
        fields={rowBasedSpendExportFields}
        firmographicsFields={firmographicsExportFields}
        value={fieldConfiguration}
        onChange={setFieldConfiguration}
        title="Row-Based Spend Fields"
        checkboxLabel="Export All Row-Based Spend Fields"
        disabled={isDisabled}
      />
      <FormControlLabel
        control={
          <Switch
            checked={includeSMB}
            onChange={(e) => setIncludeSMB(e.target.checked)}
            disabled={isDisabled}
            data-testid="row-based-spend-smb-toggle"
          />
        }
        label="Include SMB data"
      />
    </Stack>
  );
};
